// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.emote-drawer {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: radial-gradient(70% 60% at 50% 45%, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.72)), rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(3px);
  animation: drawer-scrim 0.22s ease-out;
}
.emote-drawer__stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transform-origin: center;
}
.emote-drawer__panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  display: grid;
  grid-template-columns: 210px 750px 290px;
  gap: 22px;
  width: 1360px;
  height: 690px;
  padding: 22px;
  background: radial-gradient(110% 80% at 0% 0%, rgba(255, 255, 255, 0.06), transparent 55%), rgba(11, 15, 19, 0.96);
  animation: drawer-in 0.38s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.emote-drawer__panel * {
  box-sizing: border-box;
}
.emote-drawer__tabs {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 18px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.emote-drawer__tab-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 18px;
  height: 44px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid var(--gold-dark);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.03), 0 6px 18px rgba(0, 0, 0, 0.35);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: none;
}
.emote-drawer__tab {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 44px;
  padding: 0 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.16s ease, transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.emote-drawer__tab:hover {
  color: #ebe8e1;
  transform: translateX(3px);
}
.emote-drawer__tab.is-active {
  color: var(--gold-light);
}
.emote-drawer__tab-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.emote-drawer__tab-count {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  flex: none;
}
.emote-drawer__main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.emote-drawer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.emote-drawer__title {
  margin: 0;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.emote-drawer__pager {
  display: flex;
  gap: 6px;
}
.emote-drawer__page {
  width: 22px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.14);
  transition: background-color 0.2s ease, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.emote-drawer__page.is-on {
  background: var(--gold-main);
  transform: scaleX(1.25);
}
.emote-drawer__grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}
.emote-drawer__grid li {
  animation: drawer-card 0.42s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: calc(var(--i) * 22ms);
}
.emote-drawer__card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  text-align: left;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
  cursor: default;
  transition: transform 0.24s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.24s ease;
}
.emote-drawer__card.is-active {
  transform: translateY(-4px) scale(1.035);
  border-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.09);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.04);
}
.emote-drawer__thumb {
  display: block;
  aspect-ratio: 1/0.92;
  background: radial-gradient(80% 90% at 50% 100%, rgba(255, 255, 255, 0.08), transparent 70%), rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
}
.emote-drawer__thumb img, .emote-drawer__thumb canvas {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.emote-drawer__card.is-active .emote-drawer__thumb img, .emote-drawer__card.is-active .emote-drawer__thumb canvas {
  transform: scale(1.06);
}
.emote-drawer__name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.6em;
  padding: 8px 10px 9px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #aeaba2;
  transition: color 0.16s ease;
}
.emote-drawer__card.is-active .emote-drawer__name {
  color: #ebe8e1;
}
.emote-drawer__family {
  position: absolute;
  top: 7px;
  right: 7px;
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  color: var(--gold-light);
  background: rgba(0, 0, 0, 0.62);
  border: 1px solid var(--gold-dark);
}
.emote-drawer__empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  animation: drawer-card 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.emote-drawer__empty p {
  margin: 0;
  font-size: 18px;
  color: #aeaba2;
}
.emote-drawer__empty .emote-drawer__empty-sub {
  font-size: 14px;
  color: #8d8a82;
  max-width: 360px;
}
.emote-drawer__preview {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-left: 22px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
}
.emote-drawer__preview-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  animation: drawer-preview 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.emote-drawer__stage {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 14px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: radial-gradient(90% 70% at 50% 100%, rgba(255, 255, 255, 0.1), transparent 70%), rgba(0, 0, 0, 0.35);
  overflow: hidden;
}
.emote-drawer__stage img, .emote-drawer__stage canvas {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
}
.emote-drawer__preview-title {
  margin: 0 0 10px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.emote-drawer__variants {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.emote-drawer__variant {
  width: 34px;
  height: 34px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: default;
  transition: transform 0.18s cubic-bezier(0.16, 1, 0.3, 1), background-color 0.14s ease, color 0.14s ease, border-color 0.14s ease;
}
.emote-drawer__variant.is-on {
  transform: translateY(-2px);
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.emote-drawer__hint {
  margin: 0 0 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-size: 13px;
}
.emote-drawer__hint kbd {
  display: inline-block;
  padding: 0 6px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #aeaba2;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom-width: 2px;
  border-radius: 4px;
}
.emote-drawer__preview-idle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  animation: drawer-preview 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.emote-drawer__idle-title {
  margin: 0 0 12px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.emote-drawer__favorites {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: drawer-in 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.06s both;
}
.emote-drawer__favorites * {
  box-sizing: border-box;
}
.emote-drawer__fav {
  position: relative;
  width: 64px;
  height: 64px;
  padding: 0;
  overflow: hidden;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: default;
  transition: transform 0.22s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.16s ease, box-shadow 0.22s ease;
}
.emote-drawer__fav img, .emote-drawer__fav canvas {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}
.emote-drawer__fav.is-empty {
  border-style: dashed;
  border-color: rgba(255, 255, 255, 0.12);
  background: transparent;
}
.emote-drawer__fav.is-active {
  transform: translateY(-5px) scale(1.06);
  border-color: var(--gold-main);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5);
}
.emote-drawer__fav.is-set {
  animation: drawer-pop 0.55s cubic-bezier(0.16, 1, 0.3, 1);
}
.emote-drawer__fav-num {
  position: absolute;
  top: 3px;
  left: 5px;
  z-index: 1;
  font-size: 12px;
  font-weight: 700;
  color: #ebe8e1;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
}

@keyframes drawer-scrim {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes drawer-in {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.975);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes drawer-card {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes drawer-preview {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes drawer-pop {
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.18);
    box-shadow: 0 0 0 3px var(--gold-main);
  }
  100% {
    transform: scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .emote-drawer,
  .emote-drawer__panel,
  .emote-drawer__favorites,
  .emote-drawer__grid li,
  .emote-drawer__preview-body,
  .emote-drawer__preview-idle,
  .emote-drawer__empty,
  .emote-drawer__fav.is-set {
    animation: none;
  }
  .emote-drawer__tab-glow,
  .emote-drawer__tab,
  .emote-drawer__card,
  .emote-drawer__thumb img,
  .emote-drawer__thumb canvas,
  .emote-drawer__fav,
  .emote-drawer__variant,
  .emote-drawer__page {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/EmoteWheel/EmoteWheel.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAFA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDDgBU;ECfV,cDMK;ECLL,8GACE;EAEF,0BAAA;EACA,sCAAA;AAEF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;AAEJ;AAEE;EDEA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECZE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,kHACE;EAEF,6DAAA;AAIJ;ADXE;EAAI,sBAAA;ACcN;AAHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,iDAAA;AAKJ;AADE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBDpCK;ECqCL,qCAAA;EACA,kCAAA;EACA,+EAAA;EACA,wDAAA;EACA,oBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yDDjDQ;ECkDR,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cD7DK;EC8DL,uBAAA;EACA,6BAAA;EACA,kBD5DK;EC6DL,eAAA;EACA,0EAAA;AAEJ;AAAI;EAAU,cDrEP;ECqEyB,0BAAA;AAIhC;AAHI;EAAc,wBAAA;AAMlB;AAHE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAKJ;AAFE;EDqDA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;EC7DmC,UAAA;AAcrC;AAXE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAaJ;AAVE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAYJ;AATE;EACE,SAAA;ED7DF,kDA3BW;EA4BX,gBAAA;EACA,eC4DqB;ED3DrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACiHP;AAbE;EACE,aAAA;EACA,QAAA;AAeJ;AAZE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,qFAAA;AAcJ;AAZI;EAAU,4BAAA;EAA8B,uBAAA;AAgB5C;AAbE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAeJ;AAbI;EACE,+DAAA;EACA,sCAAA;AAeN;AAXE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,cDxIG;ECyIH,qCD7IS;EC8IT,2CAAA;EACA,kBDtIK;ECuIL,gBAAA;EACA,eAAA;EACA,sIAAA;AAaJ;AAXI;EACE,wCAAA;EACA,8BAAA;EACA,qCAAA;EACA,+EAAA;AAaN;AATE;EACE,cAAA;EACA,oBAAA;EACA,gHACE;EAEF,kDAAA;EACA,gBAAA;AASJ;AAPI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,wDAAA;AASN;AALE;EACoC,sBAAA;AAOtC;AALE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDvLK;ECwLL,4BAAA;AAOJ;AAJE;EAA4B,cD5LvB;ACmMP;AAJE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;ED9DF,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;ECwDE,wBAAA;EACA,+BAAA;EACA,kCAAA;AAcJ;AAXE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,8DAAA;AAaJ;AAXI;EAAI,SAAA;EAAW,eAAA;EAAiB,cDlN3B;ACkOT;AAfI;EAA2B,eAAA;EAAiB,cDlNvC;ECkN2D,gBAAA;AAoBpE;AAhBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;AAkBJ;AAfE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iEAAA;AAiBJ;AAdE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBDvOK;ECwOL,0CAAA;EACA,gHACE;EAEF,gBAAA;AAcJ;AAZI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AAcN;AAVE;EACE,gBAAA;ED1NF,kDA3BW;EA4BX,gBAAA;EACA,eCyNqB;EDxNrB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC+QP;AAdE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAgBJ;AAbE;EACE,WAAA;EACA,YAAA;EACA,yDDlQQ;ECmQR,eAAA;EACA,gBAAA;EACA,cD7QK;EC8QL,qCAAA;EACA,0CAAA;EACA,kBD5QK;EC6QL,eAAA;EACA,iIAAA;AAeJ;AAbI;EACE,2BAAA;EACA,cDjRM;ECkRN,4BAAA;EACA,8BAAA;AAeN;AAXE;EACE,eAAA;ED5OF,eAAA;EACA,gBAAA;EACA,cAlDO;EC8RL,eAAA;AAeJ;AAbI;EACE,qBAAA;EACA,cAAA;EACA,yDD5RM;EC6RN,eAAA;EACA,gBAAA;EACA,cDvSG;ECwSH,0CAAA;EACA,wBAAA;EACA,kBAAA;AAeN;AAXE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,iEAAA;AAaJ;AAVE;EACE,gBAAA;EDrRF,kDA3BW;EA4BX,gBAAA;EACA,eCoRqB;EDnRrB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC0UP;AAbE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EDpTF,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC0SE,mEAAA;AAqBJ;ADzUE;EAAI,sBAAA;AC4UN;AArBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,cD3UG;EC4UH,qCDhVS;ECiVT,0CAAA;EACA,kBDzUK;EC0UL,eAAA;EACA,yGAAA;AAuBJ;AArBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;AAuBN;AApBI;EACE,oBAAA;EACA,uCD9VC;EC+VD,uBAAA;AAsBN;AAnBI;EACE,uCAAA;EACA,8BAAA;EACA,0CAAA;AAqBN;AAlBI;EAAW,yDAAA;AAqBf;AAlBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cDhXG;ECiXH,yCAAA;AAoBJ;;AAhBA;EACE;IAAO,UAAA;EAoBP;EAnBA;IAAO,UAAA;EAsBP;AACF;AApBA;EACE;IAAO,UAAA;IAAY,wCAAA;EAwBnB;EAvBA;IAAO,UAAA;IAAY,eAAA;EA2BnB;AACF;AAzBA;EACE;IAAO,UAAA;IAAY,uCAAA;EA6BnB;EA5BA;IAAO,UAAA;IAAY,eAAA;EAgCnB;AACF;AA9BA;EACE;IAAO,UAAA;IAAY,2BAAA;EAkCnB;EAjCA;IAAO,UAAA;IAAY,eAAA;EAqCnB;AACF;AAnCA;EACE;IAAO,mBAAA;EAsCP;EArCA;IAAO,sBAAA;IAAwB,sCAAA;EAyC/B;EAxCA;IAAO,mBAAA;EA2CP;AACF;AAzCA;EACE;;;;;;;;IAO4B,eAAA;EA4C5B;EA1CA;;;;;;;;IAOsB,gBAAA;EA6CtB;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Emote drawer: themes on the left, animated cards, a large preview, the nine favorites below.\n// One radius scale (the shared 6px), the accent only through the palette tokens, motion limited to\n// transform and opacity, all switched off for reduced motion.\n$ease: cubic-bezier(0.16, 1, 0.3, 1);\n\n.emote-drawer {\n  position: fixed;\n  inset: 0;\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ink.$font-text;\n  color: ink.$text;\n  background:\n    radial-gradient(70% 60% at 50% 45%, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.72)),\n    rgba(0, 0, 0, 0.35);\n  backdrop-filter: blur(3px);\n  animation: drawer-scrim 0.22s ease-out;\n\n  &__stack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    transform-origin: center;\n  }\n\n  // ---- panel ---------------------------------------------------------------\n  &__panel {\n    @include ink.panel;\n    display: grid;\n    grid-template-columns: 210px 750px 290px;\n    gap: 22px;\n    width: 1360px;\n    height: 690px;\n    padding: 22px;\n    background:\n      radial-gradient(110% 80% at 0% 0%, rgba(255, 255, 255, 0.06), transparent 55%),\n      ink.$ink;\n    animation: drawer-in 0.38s $ease both;\n  }\n\n  // ---- themes ----------------------------------------------------------------\n  &__tabs {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding-right: 18px;\n    border-right: 1px solid ink.$line;\n  }\n\n  // The marker that slides to the active theme\n  &__tab-glow {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 18px;\n    height: 44px;\n    border-radius: ink.$radius;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid var(--gold-dark);\n    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.03), 0 6px 18px rgba(0, 0, 0, 0.35);\n    transition: transform 0.3s $ease;\n    pointer-events: none;\n  }\n\n  &__tab {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    height: 44px;\n    padding: 0 12px;\n    font-family: ink.$font-text;\n    font-size: 15px;\n    font-weight: 600;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: color 0.16s ease, transform 0.2s $ease;\n\n    &:hover { color: ink.$text; transform: translateX(3px); }\n    &.is-active { color: var(--gold-light); }\n  }\n\n  &__tab-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__tab-count { @include ink.badge; flex: none; }\n\n  // ---- grid --------------------------------------------------------------------\n  &__main {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 14px;\n  }\n\n  &__title {\n    margin: 0;\n    @include ink.title(26px);\n  }\n\n  &__pager {\n    display: flex;\n    gap: 6px;\n  }\n\n  &__page {\n    width: 22px;\n    height: 4px;\n    border-radius: 2px;\n    background: rgba(255, 255, 255, 0.14);\n    transition: background-color 0.2s ease, transform 0.25s $ease;\n\n    &.is-on { background: var(--gold-main); transform: scaleX(1.25); }\n  }\n\n  &__grid {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 12px;\n\n    li {\n      animation: drawer-card 0.42s $ease both;\n      animation-delay: calc(var(--i) * 22ms);\n    }\n  }\n\n  &__card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0;\n    text-align: left;\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    overflow: hidden;\n    cursor: default;\n    transition: transform 0.24s $ease, border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.24s ease;\n\n    &.is-active {\n      transform: translateY(-4px) scale(1.035);\n      border-color: var(--gold-main);\n      background: rgba(255, 255, 255, 0.09);\n      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.04);\n    }\n  }\n\n  &__thumb {\n    display: block;\n    aspect-ratio: 1 / 0.92;\n    background:\n      radial-gradient(80% 90% at 50% 100%, rgba(255, 255, 255, 0.08), transparent 70%),\n      rgba(0, 0, 0, 0.3);\n    border-bottom: 1px solid ink.$line;\n    overflow: hidden;\n\n    img, canvas {\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: top center;\n      transition: transform 0.4s $ease;\n    }\n  }\n\n  &__card.is-active &__thumb img,\n  &__card.is-active &__thumb canvas { transform: scale(1.06); }\n\n  &__name {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    min-height: 2.6em;\n    padding: 8px 10px 9px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: ink.$text-2;\n    transition: color 0.16s ease;\n  }\n\n  &__card.is-active &__name { color: ink.$text; }\n\n  // How many variants a family holds\n  &__family {\n    position: absolute;\n    top: 7px;\n    right: 7px;\n    @include ink.badge;\n    color: var(--gold-light);\n    background: rgba(0, 0, 0, 0.62);\n    border: 1px solid var(--gold-dark);\n  }\n\n  &__empty {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    text-align: center;\n    animation: drawer-card 0.4s $ease both;\n\n    p { margin: 0; font-size: 18px; color: ink.$text-2; }\n    .emote-drawer__empty-sub { font-size: 14px; color: ink.$text-3; max-width: 360px; }\n  }\n\n  // ---- preview ----------------------------------------------------------------\n  &__preview {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    padding-left: 22px;\n    border-left: 1px solid ink.$line;\n  }\n\n  &__preview-body {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    animation: drawer-preview 0.3s $ease both;\n  }\n\n  &__stage {\n    position: relative;\n    flex: 1 1 auto;\n    min-height: 0;\n    margin-bottom: 14px;\n    border-radius: ink.$radius;\n    border: 1px solid ink.$line-strong;\n    background:\n      radial-gradient(90% 70% at 50% 100%, rgba(255, 255, 255, 0.1), transparent 70%),\n      rgba(0, 0, 0, 0.35);\n    overflow: hidden;\n\n    img, canvas {\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      object-position: center bottom;\n    }\n  }\n\n  &__preview-title {\n    margin: 0 0 10px;\n    @include ink.title(20px);\n  }\n\n  &__variants {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 12px;\n  }\n\n  &__variant {\n    width: 34px;\n    height: 34px;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    font-weight: 700;\n    color: ink.$text-2;\n    background: rgba(255, 255, 255, 0.07);\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    cursor: default;\n    transition: transform 0.18s $ease, background-color 0.14s ease, color 0.14s ease, border-color 0.14s ease;\n\n    &.is-on {\n      transform: translateY(-2px);\n      color: ink.$on-accent;\n      background: var(--gold-main);\n      border-color: var(--gold-main);\n    }\n  }\n\n  &__hint {\n    margin: 0 0 6px;\n    @include ink.hint;\n    font-size: 13px;\n\n    kbd {\n      display: inline-block;\n      padding: 0 6px;\n      font-family: ink.$font-text;\n      font-size: 12px;\n      font-weight: 700;\n      color: ink.$text-2;\n      border: 1px solid ink.$line-strong;\n      border-bottom-width: 2px;\n      border-radius: 4px;\n    }\n  }\n\n  &__preview-idle {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n    animation: drawer-preview 0.3s $ease both;\n  }\n\n  &__idle-title {\n    margin: 0 0 12px;\n    @include ink.title(22px);\n  }\n\n  // ---- favorites --------------------------------------------------------------\n  &__favorites {\n    display: flex;\n    gap: 10px;\n    padding: 10px 14px;\n    @include ink.panel;\n    animation: drawer-in 0.42s $ease 0.06s both;\n  }\n\n  &__fav {\n    position: relative;\n    width: 64px;\n    height: 64px;\n    padding: 0;\n    overflow: hidden;\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    cursor: default;\n    transition: transform 0.22s $ease, border-color 0.16s ease, box-shadow 0.22s ease;\n\n    img, canvas {\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: top center;\n    }\n\n    &.is-empty {\n      border-style: dashed;\n      border-color: ink.$line;\n      background: transparent;\n    }\n\n    &.is-active {\n      transform: translateY(-5px) scale(1.06);\n      border-color: var(--gold-main);\n      box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5);\n    }\n\n    &.is-set { animation: drawer-pop 0.55s $ease; }\n  }\n\n  &__fav-num {\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    z-index: 1;\n    font-size: 12px;\n    font-weight: 700;\n    color: ink.$text;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);\n  }\n}\n\n@keyframes drawer-scrim {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes drawer-in {\n  from { opacity: 0; transform: translateY(16px) scale(0.975); }\n  to   { opacity: 1; transform: none; }\n}\n\n@keyframes drawer-card {\n  from { opacity: 0; transform: translateY(12px) scale(0.96); }\n  to   { opacity: 1; transform: none; }\n}\n\n@keyframes drawer-preview {\n  from { opacity: 0; transform: translateX(10px); }\n  to   { opacity: 1; transform: none; }\n}\n\n@keyframes drawer-pop {\n  0%   { transform: scale(1); }\n  35%  { transform: scale(1.18); box-shadow: 0 0 0 3px var(--gold-main); }\n  100% { transform: scale(1); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .emote-drawer,\n  .emote-drawer__panel,\n  .emote-drawer__favorites,\n  .emote-drawer__grid li,\n  .emote-drawer__preview-body,\n  .emote-drawer__preview-idle,\n  .emote-drawer__empty,\n  .emote-drawer__fav.is-set { animation: none; }\n\n  .emote-drawer__tab-glow,\n  .emote-drawer__tab,\n  .emote-drawer__card,\n  .emote-drawer__thumb img,\n  .emote-drawer__thumb canvas,\n  .emote-drawer__fav,\n  .emote-drawer__variant,\n  .emote-drawer__page { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
